<!-- Etichetta -->
<div class="pl-ms ts-caption-bold"
     [class.label-invalid]="isInvalid()">{{ label }}
</div>

<!-- Campo dinamico -->
<div class="pt-sm" [ngSwitch]="type">

  <!-- Email -->
  <ng-container *ngSwitchCase="'email'">
    <ng-container
      *ngTemplateOutlet="standardInput; context: { type: 'email', icon: 'mail-outline' }"></ng-container>
  </ng-container>

  <!-- Password -->
  <ng-container *ngSwitchCase="'password'">
    <ng-container
      *ngTemplateOutlet="standardInput; context: { type: passwordType, icon: passwordType === 'password' ? 'eye-outline' : 'eye-off-outline', iconClick: togglePwdType.bind(this) }"></ng-container>
  </ng-container>

  <!-- Date / Time -->
  <ng-container *ngSwitchCase="'date'">
    <ng-container *ngTemplateOutlet="datePickerContent"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'time'">
    <ng-container *ngTemplateOutlet="datePickerContent"></ng-container>
  </ng-container>

  <!-- File Upload -->
  <ng-container *ngSwitchCase="'file'">
    <app-upload-image [image]="control.value" (change)="onChangeImage($event)"></app-upload-image>
  </ng-container>

  <!-- Select -->
  <ng-container *ngSwitchCase="'select'">
    <ion-item lines="none" [class.invalid-input]="isInvalid()" (click)="select.open()"
              style="--background: var(--input-bg);">
      <ion-input [value]="getSelectedLabel()" readonly [placeholder]="placeHolder"></ion-input>
      <ion-icon name="caret-down-outline" slot="end"></ion-icon>
    </ion-item>
    <ion-select #select style="display: none;"
                [interfaceOptions]="{ header: label }"
                class="simple" [formControl]="control">
      <ion-select-option *ngFor="let opt of options" [value]="opt.value">{{ opt?.label }}</ion-select-option>
    </ion-select>
  </ng-container>

  <!-- Editor -->
  <ng-container *ngSwitchCase="'editor'">
    <div [innerHTML]="control.value"
         [class.invalid-input]="isInvalid()"
         (click)="editorModalRef.present()"
         class="simple-textarea-preview">
    </div>

    <ion-modal #editorModalRef>
      <ng-template>
        <ion-header [translucent]="false">
          <ion-toolbar>
            <div>
              <app-back-btn [onBackFn]="onCloseEditorModal.bind(this)"></app-back-btn>
            </div>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <app-editor [control]="editorControl"></app-editor>
        </ion-content>
        <ion-footer>
          <ion-toolbar>
            <ion-button [disabled]="!editorControl?.value"
                        class="secondary w-100" (click)="onSave()">
              Salva
            </ion-button>
          </ion-toolbar>
        </ion-footer>
      </ng-template>
    </ion-modal>
  </ng-container>

  <!-- Default -->
  <ng-container *ngSwitchDefault>
    <ng-container
      *ngTemplateOutlet="standardInput; context: { type: type, icon: getIconName(), showIcon: showIcon() }"></ng-container>
  </ng-container>
</div>

<!-- Template standard per input -->
<ng-template #standardInput let-type="type" let-icon="icon" let-iconClick="iconClick" let-showIcon="showIcon">
  <ion-item [id]="id"
            lines="none"
            [class.invalid-input]="isInvalid()"
            style="--background: var(--input-bg);">
    <ion-input [formControl]="control"
               [type]="type"
               [placeholder]="placeHolder"
               class="simple"
               (click)="onInputClick();">
    </ion-input>
    <ion-icon *ngIf="icon" [name]="icon" (click)="iconClick?.()" slot="end"></ion-icon>
  </ion-item>
</ng-template>

<!-- Template date/time -->
<ng-template #datePickerContent>
  <ion-item [id]="id" lines="none" [class.invalid-input]="isInvalid()" style="--background: var(--input-bg);">
    <ion-input
      [value]="control.value | date:(type === 'date' ? 'dd/MM/yyyy' : 'HH:mm')"
      readonly
      [placeholder]="placeHolder">
    </ion-input>
    <ion-icon [name]="type === 'date' ? 'calendar-outline' : 'timer-outline'" slot="end"></ion-icon>
  </ion-item>
  <ion-modal [trigger]="id" #modal class="datetime-modal">
    <ng-template>
      <div class="calendar-wrapper px-sm">
        <ion-datetime [presentation]="type"
                      [min]="min"
                      [max]="max"
                      minute-values="0,15,30,45"
                      (ionChange)="onSetDateTimeValue($event)"
                      id="datetime">
        </ion-datetime>
      </div>
      <div class="p-sm d-flex ion-justify-content-end">
        <ion-button (click)="modal.dismiss()">{{ 'Salva' | translate }}</ion-button>
      </div>
    </ng-template>
  </ion-modal>
</ng-template>

<!-- Errori -->
<div *ngIf="isInvalid()">
  <div *ngFor="let errorKey of getErrorKeys()">
    <div class="ts-caption text-error pt-xs">{{ ('VALIDATORS.' + errorKey) | translate }}</div>
  </div>
</div>
